




























import { Component, Vue, Prop } from 'vue-property-decorator';

export interface UploadFile {
  value: any | null;
  error: boolean | string;
}

@Component({
  components: {},
})
export default class UploadQuestionFile extends Vue {
  @Prop()
  file!: UploadFile;

  get uploadButtonClass() {
    return !this.file.error
      ? `border-1 border-dashed border-gray-200 flex justify-center items-center rounded w-full
  py-50 cursor-pointer hover:border-red-100 text-red-100 relative`
      : `border-1 border-dashed border-red-100 flex justify-center items-center rounded w-full
  py-50 cursor-pointer hover:border-red-100 text-red-100 relative bg-red-300`;
  }

  handleFileUpload(files: any) {
    this.file.value = files[0];
    this.file.error = false;
  }

  truncateString(text: string) {
    const limit = 26;
    if (text.length <= limit) {
      return text;
    }
    return text.slice(0, limit / 2) + '...' + text.slice(-limit / 2);
  }
}
